import "./HealthProfileSkeleton.scss";

export const HealthProfileSkeleton = () => {
  return (
    <div className="health-skeleton-container">
      {/* Header with title and download button */}
      <div className="health-skeleton-header">
        <div className="health-skeleton-title pulse"></div>
        <div className="health-skeleton-download-button pulse"></div>
      </div>

      <div className="health-skeleton-divider"></div>

      {/* Personal data card */}
      <div className="health-skeleton-personal-card">
        {/* User avatar and name */}
        <div className="health-skeleton-user-header">
          <div className="health-skeleton-avatar pulse"></div>
          <div className="health-skeleton-name pulse"></div>
        </div>

        {/* Personal data grid */}
        <div className="health-skeleton-data-grid">
          {/* Row 1 */}
          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          {/* Row 2 */}
          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          {/* Row 3 */}
          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>

          <div className="health-skeleton-data-item">
            <div className="health-skeleton-data-label pulse"></div>
            <div className="health-skeleton-data-value pulse"></div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="health-skeleton-tabs">
        <div className="health-skeleton-tab-active pulse"></div>
        <div className="health-skeleton-tab pulse"></div>
      </div>

      <div className="health-skeleton-divider"></div>

      {/* Exemptions section */}
      <div className="health-skeleton-exemptions">
        <div className="health-skeleton-section-header">
          <div className="health-skeleton-section-title pulse"></div>
          <div className="health-skeleton-section-button pulse"></div>
        </div>

        <div className="health-skeleton-divider"></div>

        {/* Exemption item */}
        <div className="health-skeleton-exemption-item">
          <div className="health-skeleton-exemption-header">
            <div className="health-skeleton-exemption-code pulse"></div>
            <div className="health-skeleton-exemption-type pulse"></div>
            <div className="health-skeleton-arrow pulse"></div>
          </div>

          {/* Exemption details */}
          <div className="health-skeleton-exemption-details">
            <div className="health-skeleton-exemption-grid">
              <div className="health-skeleton-data-item">
                <div className="health-skeleton-data-label pulse"></div>
                <div className="health-skeleton-data-value pulse"></div>
              </div>

              <div className="health-skeleton-data-item">
                <div className="health-skeleton-data-label pulse"></div>
                <div className="health-skeleton-data-value pulse"></div>
              </div>

              <div className="health-skeleton-data-item">
                <div className="health-skeleton-data-label pulse"></div>
                <div className="health-skeleton-data-value pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
